/*
 *
 * This File Containes Common Functions used in the Project
 *
 */

export const replaceWithBr = (data) => {
  return data.replace(/\n/g, "<br />");
};

export const convertToInr = (value) => {
  return value
    ?.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    })
    .split(".")[0];
};
